(function () {
  'use strict';

  if (window.NestPdpDialogScrollLock) return;

  var root = document.documentElement;
  var lockClass = 'nest-pdp-native-dialog-open';
  var ownershipCount = 0;

  function canScroll(scroller, deltaY) {
    if (!scroller || !deltaY || scroller.scrollHeight <= scroller.clientHeight + 1) return false;
    if (deltaY < 0) return scroller.scrollTop > 0;
    return scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 1;
  }

  function lock(overlay, scroller) {
    if (!overlay || !scroller) return function () {};

    var released = false;
    var touchY = null;

    function isInsideScroller(target) {
      return !!(target && scroller.contains(target));
    }

    function wheelGuard(event) {
      if (!isInsideScroller(event.target) || !canScroll(scroller, event.deltaY)) {
        event.preventDefault();
      }
    }

    function touchStart(event) {
      touchY = event.touches && event.touches.length ? event.touches[0].clientY : null;
    }

    function touchMove(event) {
      if (touchY === null || !event.touches || !event.touches.length) {
        event.preventDefault();
        return;
      }

      var nextY = event.touches[0].clientY;
      var deltaY = touchY - nextY;
      touchY = nextY;
      if (!isInsideScroller(event.target) || !canScroll(scroller, deltaY)) event.preventDefault();
    }

    ownershipCount += 1;
    root.classList.add(lockClass);
    overlay.classList.add('nest-pdp-scroll-guard');
    scroller.classList.add('nest-pdp-scroll-guard__scroller');
    overlay.addEventListener('wheel', wheelGuard, { passive: false });
    overlay.addEventListener('touchstart', touchStart, { passive: true });
    overlay.addEventListener('touchmove', touchMove, { passive: false });

    return function release() {
      if (released) return;
      released = true;
      overlay.removeEventListener('wheel', wheelGuard, { passive: false });
      overlay.removeEventListener('touchstart', touchStart, { passive: true });
      overlay.removeEventListener('touchmove', touchMove, { passive: false });
      overlay.classList.remove('nest-pdp-scroll-guard');
      scroller.classList.remove('nest-pdp-scroll-guard__scroller');
      ownershipCount = Math.max(0, ownershipCount - 1);
      if (!ownershipCount) root.classList.remove(lockClass);
    };
  }

  window.NestPdpDialogScrollLock = { lock: lock };
})();
